import {Dialog} from './dialog';
import {Question} from './question';

export class Construct {
  public _id: number;
  public name: string;
  public description: string;
  public questions: Array<Question>;
  public isDistributed: boolean;
  public dialogs: Array<Dialog>;
  public keptQuestionIds?: Array<String>;
  public languageCount?: {de: Number, en: Number};
  public varName?: boolean;

  constructor(id?: number) {
    this._id = id;
    this.name = '';
    this.description = '';
    this.questions = [];
    this.isDistributed = false;
    this.dialogs = [];
  }

  public static create(data: Construct): Construct {
    const construct: Construct = new Construct();
    construct._id = data._id;
    construct.name = data.name;
    construct.description = data.description;
    construct.isDistributed = data.isDistributed;
    construct.dialogs = data.dialogs;
    construct.questions = data.questions.map((question) => {
      return Question.create(question);
    });

    return construct;
  }

  public static createLight(data: Construct): Construct {
    const construct: Construct = new Construct();
    construct._id = data._id;
    construct.name = data.name;
    construct.description = data.description;
    construct.isDistributed = undefined;
    construct.languageCount = {
      de: construct.getLanguageCount(data.questions, 'de'),
      en: construct.getLanguageCount(data.questions, 'en'),
    };
    return construct;
  }

  public static createLight2(data: Construct): Construct {
    const construct: Construct = new Construct();
    construct._id = data._id;
    construct.name = data.name;
    construct.description = data.description;
    construct.isDistributed = undefined;
    construct.keptQuestionIds = data.keptQuestionIds;
    construct.varName = data.varName;
    return construct;
  }

  public addEmptyQuestion(): void {
    const newQuestion: Question = new Question();
    this.questions.push(newQuestion);
  }

  public getLanguageCount(questions: Array<Question>, language: string): Number {
    return questions.filter((question: Question) => {
      return question.text[language] !== null &&
        question.text[language] !== undefined &&
        question.text[language].length > 0;
    }).length;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/classes/construct.ts